"use client"

import { useMemo } from "react"
import { useTranslations } from "next-intl"
import { getPlanFeatureFormatters } from "@/components/billing/plan-features"
import { useCreditFormatters } from "@/hooks/use-credit-formatters"

export function usePlanFeatures() {
  const t = useTranslations("PlanFeatures")
  const { formatCredits } = useCreditFormatters()
  return useMemo(() => getPlanFeatureFormatters(t, formatCredits), [t, formatCredits])
}
